import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { ErrorToast, ShowInputError, SuccessToast } from "../../../../widgets/AppToast";
import { useParams } from "react-router-dom";

const { TextArea } = Input;

function CargoRemarks() {
  const { eng_log_basic_id } = useParams();
  const [staffDashboard, setStaffDashboard] = useState({});
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [freeText, setFreeText] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Load staffDashboard from localStorage
  useEffect(() => {
    const staffData = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staffData);
    if (parsedData) {
      setStaffDashboard(parsedData);
    }
  }, []);

  // Load existing remarks after staffDashboard is ready
  useEffect(() => {
    if (
      staffDashboard &&
      Array.isArray(staffDashboard.voyage_details) &&
      staffDashboard.voyage_details.length > 0
    ) {
      const voyage_id = staffDashboard.voyage_details[0].id;
      GET_CARGO_REMARKS(voyage_id);
    }
  }, [staffDashboard]);

  const GET_CARGO_REMARKS = async (voyage_id) => {
    const formData = new FormData();
    formData.append("voyage_id", voyage_id);
    formData.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);

    try {
      const res = await post(ApiURL.get_cargo_remarks_details_st, formData);
      if (res?.status === true && res?.remark_data) {
        setFreeText(res?.remark_data?.cargo_remark || "");
        setIsUpdateMode(res?.remark_data?.complete_status || false);
        if (res?.remark_data?.complete_status === true) {
          setSubmitStatus(true);
        }
      }
    } catch (err) {
      ErrorToast("Error", "Failed to fetch cargo remarks.");
    }
  };

  const handleSaveOrUpdate = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("voyage_id", staffDashboard?.voyage_details?.[0]?.id || "");
    formData.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
    formData.append("cargo_remark", freeText || "");

    const apiUrl = isUpdateMode ? ApiURL.get_cargo_remarks_details_st : ApiURL.add_cargo_remarks_st;

    try {
      const res = await post(apiUrl, formData);
      if (res?.status === true) {
        SuccessToast(isUpdateMode ? "Updated successfully" : "Saved successfully", res.message);
        setErrors({});
        setSubmitStatus(true);
        setIsUpdateMode(true);
      } else {
        ErrorToast("Error", res.message);
        setErrors(res.errors || {});
      }
    } catch (err) {
      ErrorToast("Error", "Something went wrong.");
    }
    setLoader(false);
  };

  return (
    <div className="white-container">
      <div className="row">
        <div className="col-12">
          <div className="input-box">
            <label>Cargo Machinery Remarks</label>
            <TextArea
              rows={6}
              placeholder="Cargo Machinery comments"
              maxLength={1000}
              // disabled={submitStatus}
              value={freeText}
              onChange={(e) => setFreeText(e.target.value)}
            />
            {errors.cargo_machinery_remarks && (
              <ShowInputError errorMessage={errors.cargo_machinery_remarks} />
            )}
          </div>
        </div>
      </div>

      <Button
        type="primary"
        loading={loader}
        // disabled={submitStatus}
        onClick={handleSaveOrUpdate}
      >
        {isUpdateMode ? "Update" : "Save"}
      </Button>
    </div>
  );
}

export default CargoRemarks;
